import type {
  IOnboardingGetBrokerageApproverParams,
  IOnboardingGetBrokerageApproverRequest,
  IOnboardingGetBrokerageApproverResponse,
} from '@/app-package';

import axios from 'axios';

const getBrokerageApprover = async ({
  orgClaimHash,
}: IOnboardingGetBrokerageApproverParams) => {
  const url = `/onboarding/brokerage_setup/get_approver/${orgClaimHash}`;

  const config: IOnboardingGetBrokerageApproverRequest = { url, method: 'get' };

  const { data } =
    await axios.request<IOnboardingGetBrokerageApproverResponse>(config);

  return data;
};

export default getBrokerageApprover;
